import { getResponsiveSpacingPixels } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/spacing";
import {
  DynamicVariable,
  mapResponsivePropToCSSVars,
} from "@faire/retailer-visitor-shared/lib/tailwindUtils";
import { IFlowLayout } from "@faire/web-api--source/indigofair/data/IFlowLayout";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";

const varMobileRowGap: DynamicVariable<"--f-sdui-fl-rg-m"> = {
  variable: "--f-sdui-fl-rg-m",
  className: "gap-y-(--f-sdui-fl-rg-m)",
};

const varTabletRowGap: DynamicVariable<"--f-sdui-fl-rg-md"> = {
  variable: "--f-sdui-fl-rg-md",
  className: "md:gap-y-(--f-sdui-fl-rg-md)",
};

const varDesktopRowGap: DynamicVariable<"--f-sdui-fl-rg-lg"> = {
  variable: "--f-sdui-fl-rg-lg",
  className: "lg:gap-y-(--f-sdui-fl-rg-lg)",
};

const varXLargeRowGap: DynamicVariable<"--f-sdui-fl-rg-xl"> = {
  variable: "--f-sdui-fl-rg-xl",
  className: "xl:gap-y-(--f-sdui-fl-rg-xl)",
};

const varMobileColumnGap: DynamicVariable<"--f-sdui-fl-cg-m"> = {
  variable: "--f-sdui-fl-cg-m",
  className: "gap-x-(--f-sdui-fl-cg-m)",
};

const varTabletColumnGap: DynamicVariable<"--f-sdui-fl-cg-md"> = {
  variable: "--f-sdui-fl-cg-md",
  className: "md:gap-x-(--f-sdui-fl-cg-md)",
};

const varDesktopColumnGap: DynamicVariable<"--f-sdui-fl-cg-lg"> = {
  variable: "--f-sdui-fl-cg-lg",
  className: "lg:gap-x-(--f-sdui-fl-cg-lg)",
};

const varXLargeColumnGap: DynamicVariable<"--f-sdui-fl-cg-xl"> = {
  variable: "--f-sdui-fl-cg-xl",
  className: "xl:gap-x-(--f-sdui-fl-cg-xl)",
};

export const getFlowLayoutRowGapStyles = (flowLayout: IFlowLayout) => {
  const clientRowSpacing = getResponsiveSpacingPixels(
    Spacing.R,
    flowLayout.row_spacing
  );

  const { vars: rowSpacingVars, classes: rowSpacingClasses } =
    mapResponsivePropToCSSVars(clientRowSpacing, {
      mobileAndAbove: varMobileRowGap,
      tabletAndAbove: varTabletRowGap,
      desktopAndAbove: varDesktopRowGap,
      xLargeAndAbove: varXLargeRowGap,
    });

  return {
    rowSpacingClasses,
    rowSpacingVars,
  };
};

const getFlowLayoutColumnGapStyles = (flowLayout: IFlowLayout) => {
  const clientColumnSpacing = getResponsiveSpacingPixels(
    Spacing.R,
    flowLayout.column_spacing
  );

  const { vars: columnSpacingVars, classes: columnSpacingClasses } =
    mapResponsivePropToCSSVars(clientColumnSpacing, {
      mobileAndAbove: varMobileColumnGap,
      tabletAndAbove: varTabletColumnGap,
      desktopAndAbove: varDesktopColumnGap,
      xLargeAndAbove: varXLargeColumnGap,
    });

  return {
    columnSpacingClasses,
    columnSpacingVars,
  };
};

export const getFlowLayoutGapStyles = (flowLayout: IFlowLayout) => {
  const { rowSpacingClasses, rowSpacingVars } =
    getFlowLayoutRowGapStyles(flowLayout);
  const { columnSpacingClasses, columnSpacingVars } =
    getFlowLayoutColumnGapStyles(flowLayout);

  return {
    rowSpacingClasses,
    rowSpacingVars,
    columnSpacingClasses,
    columnSpacingVars,
  };
};
